export default __webpack_public_path__ + "/assets/bx_exit.svg";